import React from 'react'

const RoundedBottomBorder = () => {
    return (
        <div className="border-b-4 border-solid border-yellow w-11 rounded-tr-full mr-auto ml-auto md:ml-0"></div>
    )
}

export default RoundedBottomBorder
